import * as firestore from "firebase/firestore";
import styles from "../styles/Home.module.css";

import {
    useCollectionData,
    useCollection,
} from "react-firebase-hooks/firestore";
import { firestore as db } from "../firebase";

interface Update {
    id: string;
    title: string;
    content: string;
    createdAt: firestore.Timestamp;
}

const deleteUpdate = (updateId: string, page: string) => {
    const canDelete = window.confirm("Are you sure you want to delete this announcement?");
    if (canDelete) {
        firestore.deleteDoc(firestore.doc(db, "updates_" + page, updateId));
    }
};

const UpdatesHolder = (
    { isAdmin, page }: { isAdmin: boolean; page: string } = {
        isAdmin: false,
        page: "calc",
    }
) => {
    const updatesRef = firestore.collection(db, "updates_" + page);
    // const query = updatesRef.orderBy("createdAt").limit(50);
    const query = firestore.query(
        updatesRef,
        firestore.orderBy("createdAt"),
        firestore.limit(50)
    );

    const [updates] = useCollection(query);

    const data: Update[] =
        updates?.docs
            .map((doc) => ({
                title: doc.data().title as string,
                content: doc.data().content as string,
                createdAt: doc.data().createdAt as firestore.Timestamp,
                id: doc.id,
            }))
            .reverse() || [];

    return (
        <div>
            {data &&
                data?.map((update) => (
                    <div key={update.id} className={styles.updateDiv}>
                        <h3>
                            {update.title}
                            <span
                                style={{
                                    fontSize: ".75rem",
                                    color: "#aaa",
                                    marginLeft: "10px",
                                }}
                            >
                                {update.createdAt
                                    .toDate()
                                    .toLocaleDateString() ===
                                new Date().toLocaleDateString()
                                    ? update.createdAt
                                          .toDate()
                                          .toLocaleTimeString()
                                    : update.createdAt
                                          .toDate()
                                          .toLocaleString()}
                            </span>
                            {isAdmin && (
                                <span
                                    className="material-icons"
                                    style={{
                                        color: "#E57373",
                                        cursor: "pointer",
                                        marginLeft: "10px",
                                    }}
                                    onClick={() =>
                                        deleteUpdate(update.id, page)
                                    }
                                >
                                    delete
                                </span>
                            )}
                        </h3>
                        <div
                            style={{ fontWeight: "lighter" }}
                            dangerouslySetInnerHTML={{ __html: update.content }}
                        ></div>
                    </div>
                ))}
        </div>
    );
};

export default UpdatesHolder;
